const isPlainObject = (value) => {
  if (!value || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

export const transformDates = (input, dateTransformer) => {
  if (!input || typeof input !== 'object') {
    return input;
  }

  if (!Array.isArray(input) && !isPlainObject(input)) {
    return null;
  }

  const root = Array.isArray(input) ? [] : {};
  const seen = new WeakMap([[input, root]]);
  const stack = [{ source: input, target: root }];

  while (stack.length > 0) {
    const { source, target } = stack.pop();

    if (Array.isArray(source)) {
      source.forEach((value, index) => {
        if (!value || typeof value !== 'object') {
          target[index] = value;
          return;
        }

        if (seen.has(value)) {
          target[index] = null;
          return;
        }

        if (Array.isArray(value)) {
          const child = [];
          seen.set(value, child);
          target[index] = child;
          stack.push({ source: value, target: child });
          return;
        }

        if (isPlainObject(value)) {
          const child = {};
          seen.set(value, child);
          target[index] = child;
          stack.push({ source: value, target: child });
          return;
        }

        target[index] = null;
      });
      continue;
    }

    Object.entries(source).forEach(([key, value]) => {
      if (typeof value === 'string' && key.toLowerCase().includes('date')) {
        target[key] = dateTransformer(value);
        return;
      }

      if (!value || typeof value !== 'object') {
        target[key] = value;
        return;
      }

      if (seen.has(value)) {
        target[key] = null;
        return;
      }

      if (Array.isArray(value)) {
        const child = [];
        seen.set(value, child);
        target[key] = child;
        stack.push({ source: value, target: child });
        return;
      }

      if (isPlainObject(value)) {
        const child = {};
        seen.set(value, child);
        target[key] = child;
        stack.push({ source: value, target: child });
        return;
      }

      target[key] = null;
    });
  }

  return root;
};
